import { useQuery } from '@tanstack/react-query'
import { Input, Pagination, Spin } from 'antd'
import { FaSearch } from 'react-icons/fa'
import { GetPosts } from '../../../api/posts'
import DataListNew from './DataListNew'
import { useTranslation } from 'react-i18next'

export default function DataListLoaders() {
    const { t } = useTranslation('ContestantList')
    const { data, isPending, isError } = useQuery({
        queryKey: ['contestants'],
        queryFn: GetPosts,
        refetchInterval: 10000,
        refetchIntervalInBackground: true
    })

    if (isPending) {
        return (
            <div>
                <div className="mb-5">
                    <Input
                        type="text"
                        placeholder={t('Search by name')}
                        prefix={<FaSearch className="text-white/50" />}
                        classNames={{
                            input: 'bg-transparent border-2 text-white placeholder:text-white h-full pl-2',
                            affixWrapper: 'bg-transparent'
                        } as any}
                    />
                </div>
                <div className="col-span-4 row-span-2 grid h-[70vh] w-full place-items-center bg-[#010a1b]">
                    <div className="flex flex-col gap-5">
                        <Spin size="large" />
                        <span className="text-2xl font-bold">{t('Loading data')}</span>
                    </div>
                </div>
                <Pagination className="mt-5" />
            </div>
        )
    }

    if (isError) {
        return <div>Error</div>
    }

    return <DataListNew contestants={data} />
}
